import { render, staticRenderFns } from "./interviewCandidateCardItem.vue?vue&type=template&id=61c79e0c&scoped=true"
import script from "./interviewCandidateCardItem.vue?vue&type=script&lang=js"
export * from "./interviewCandidateCardItem.vue?vue&type=script&lang=js"
import style0 from "./interviewCandidateCardItem.vue?vue&type=style&index=0&id=61c79e0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c79e0c",
  null
  
)

export default component.exports